import { ISalesDocument as InvoiceSalesDocument } from '@cemex-core/cmx-api/models/sales-document-management';
import { State } from '@cemex/cmx-client-layout';
import { Store } from '@ngrx/store';
import { take } from 'rxjs/operators';
import { OneClickSelectInvoiceAction } from '../../actions/one-click-contract.actions';
import { OneClickUpdateOrderAction } from '../../actions/one-click-orders.actions';
import { getOneClickSelectedOrder } from '../../selectors/one-click-orders.selector';

export function setInvoiceInOrder(invoice: InvoiceSalesDocument, store: Store<State>, index: number) {
  const salesDocument = invoice;
  store
    .select(getOneClickSelectedOrder)
    .pipe(take(1))
    .subscribe((order) => {
      const modded = {
        ...order,
        agreement: salesDocument && {
          agreementId: salesDocument.salesDocumentId,
          agreementCode: salesDocument.salesDocumentCode,
        },
      };

      store.dispatch(new OneClickSelectInvoiceAction(invoice, index));
      store.dispatch(new OneClickUpdateOrderAction(modded));
    });
}
